import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type GroundingCommandBarActionsSlots = {
  root: Slot<'span'>;
};

/**
 * GroundingCommandBarActions Props
 */
export type GroundingCommandBarActionsProps = ComponentProps<GroundingCommandBarActionsSlots> & {};

/**
 * State used in rendering GroundingCommandBarActions
 */
export type GroundingCommandBarActionsState = ComponentState<GroundingCommandBarActionsSlots>;
// TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from GroundingCommandBarActionsProps.
// & Required<Pick<GroundingCommandBarActionsProps, 'propName'>>
